import React from 'react';

import Grid from '@material-ui/core/Grid';

import { AreaChart, Area, Tooltip, XAxis, YAxis } from 'recharts';

class AreaChartComponent extends React.Component {

    render() {

        return (
            <Grid container direction="row"
            justifyContent="center" alignItems="center">
                <AreaChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis domain={['dataMin - 1.21', 'dataMax']} />
                    <Tooltip />
                    <Area dataKey="Value" stroke="#8884d8"
                    fillOpacity={1} />
                </AreaChart>
            </Grid>
        )
    }
}

export default AreaChartComponent;